var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vtk-sidebar-item',{attrs:{"title":"Variáveis","item-class":_vm.itemClass}},[_c('swx-dropdown',{attrs:{"block":"","variant":"outline-primary","options":_vm.colorByOptions,"disabled":_vm.busy},scopedSlots:_vm._u([{key:"value",fn:function(ref){
var value = ref.value;
var text = ref.text;
return [_c('i',{class:{
                    fas: true,
                    'fa-fw': true,
                    'fa-border-all': value.includes('CELLS'),
                    'fa-dot-circle': value.includes('POINTS')
                }}),_vm._v(_vm._s(text))]}},{key:"option",fn:function(ref){
                var option = ref.option;
return [_c('i',{class:{
                    fas: true,
                    'fa-fw': true,
                    'fa-border-all': option.value.includes('CELLS'),
                    'fa-dot-circle': option.value.includes('POINTS')
                }}),_vm._v(_vm._s(option.text))]}}]),model:{value:(_vm.colorBy),callback:function ($$v) {_vm.colorBy=$$v},expression:"colorBy"}}),(_vm.componentInfoOptions.length > 0)?_c('swx-dropdown',{staticClass:"chosen-component-select",attrs:{"block":"","variant":"outline-primary","options":_vm.componentInfoOptions,"disabled":_vm.busy},model:{value:(_vm.componentInfo),callback:function ($$v) {_vm.componentInfo=$$v},expression:"componentInfo"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }